import React from 'react'
import PropTypes from 'prop-types'
import Tab from "./tabs/Tab"
import Tabs from "./tabs/Tabs"
import SyntaxHighlighter from 'react-syntax-highlighter'
import { docco } from 'react-syntax-highlighter/dist/styles'
import css from "./lib/codemirror.css"
import codemirror from "./lib/codemirror.js";
//import css2 from "./EstiloStyles.css"

let codeMirrorInstance = null

function iframeTemplate(strings, samplePath) {
    return `
        <html>
            <head>
                <style>
                button {
                    background-color: transparent;
                    border: 2px solid #01a982;
                    border-radius: 0;
                    color: #333;
                    font-size: 19px;
                    font-size: 1.1875rem;
                    line-height: 24px;
                    font-weight: 600;
                    cursor: pointer;
                    text-align: center;
                    outline: none;
                    min-width: 120px;
                    max-width: 384px;
                }
                </style>
                <script type="text/javascript" src="./dist/index-with-deps.min.js"></script>
                <!-- <script type="text/javascript" src="../node_modules/lit-html/lit-html.js"></script> -->
                
                <script type="text/javascript" type="module">${samplePath}</script>
            </head>
            <body class="apic">
                <section id="main-content-sample" class="noBorderSection">
                    <div id="main-content"></div>
                    <div id="_sampleDomElement" class="_sampleDomElement sampleElement"></div>
                </section>
            
            </body>
        </html>
    `
}


class Content extends React.Component {
    constructor() {
        super();
        this._onClick = this._onClick.bind(this)
        this._onRequestForActive = this._onRequestForActive.bind(this)
    }
    componentWillReceiveProps(newest, prev) {
        //this.loadSample(src, true)
    }
    componentDidMount() {
        const { src } = this.props
        codeMirrorInstance = null
        this.loadSample(src, true)
    }
    componentDidUpdate() {
        const { src } = this.props
        this.loadSample(src, true)
    }
    loadSample(src, reloadCodeMirror) {
        const { codeholder, iframeholder } = this
        //const codeholder = document.getElementById("iframeholder")
            //console.log(codeholder)
            if (reloadCodeMirror) {
                let sourceCode
                if (typeof src !== "string") {
                    console.log("src source code type is looking weird")
                } else {
                    sourceCode = src
                }
                if (!codeMirrorInstance) {
                    codeMirrorInstance = codemirror(codeholder, {
                        value: sourceCode,
                        mode: "javascript",
                        theme: "3024-day",
                        lineWrapping: true,
                        lineNumbers: true,
                    });
                } else {
                    codeMirrorInstance.setValue(sourceCode)
                }
            }
            //const iframeholder = document.getElementById("iframeholder")

            const getiframe = document.getElementById("samplesIframe")

            if (getiframe) getiframe.remove()

            const iframe = document.createElement("iframe")
            iframe.setAttribute("id", "samplesIframe")
            iframe.setAttribute("style", "width: 100%; height: 500px;")
            { /*<iframe class={"samplesIframe"} id={"samplesIframe"} style={{width: "100%", height:"900px"}} ref={f => this.ifr = f}></iframe> */}
            
            iframeholder.appendChild(iframe)



        //if (ifr) {
            let iframeContent = iframeTemplate`${src}`
            //eslint-disable-next-line
            //let iframeDoc = window.frames["samplesIframe"].contentDocument;
            //console.log(ifr)
            let iframeDoc = iframe.contentDocument
            //eslint-disable-next-line
            iframeDoc.open()
            if (iframeDoc.documentElement) iframeDoc.documentElement.innerHTML = ""
            iframeDoc.writeln(iframeContent)
            iframeDoc.close()
        //}
    }
    _onClick(event) {
        this.loadSample(codeMirrorInstance.getValue(), false)
    }
    _onRequestForActive(event) {
        //this.forceUpdate();
        //this.componentDidMount()
        if (event === 0) {
            setTimeout(()=>{
                const { src } = this.props
                codeMirrorInstance = null
                this.loadSample(src, true)
            }, 1000)
        }
    }
    render() {
        const { contentDEMO, contentDEMOReact, contentDEMOJQ, contentDEMOVue, contentDOC, title, description, tag } = this.props;
        let Content;
        //<Tab title='Angular'>
        //    <SyntaxHighlighter language='javascript' style={docco}>
        //        {`Some code here...  Angular ...`}
        //    </SyntaxHighlighter>
        //</Tab>
        if (title === 'Home' || title === 'Get Started') {
            Content = (
                <div id="page-content-wrapper">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <div> {contentDOC} </div>
                                <div style={{ paddingTop: '30px' }}> {contentDEMO} </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            Content = (
                <div id="page-content-wrapper">
                <Tabs activeIndex={0} onActive={this._onRequestForActive}>
                    <Tab key={'1'} title='Play'>
                        <div id="page-content-wrapper">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div><h2>Description:</h2></div>
                                        <p> {description} </p>
                                        <div><h2>Play with Source Code:<span style={{fontSize: "75%"}}>&nbsp; &nbsp; &nbsp; (see API tab for documentation)</span></h2></div>
                                        <div id={"codeholder"} className={"codeholder"} ref={_ref => this.codeholder = _ref} style={{borderWidth: "2px", borderStyle: "inset", borderColor: "initial", borderImage: "initial"}}></div>
                                        <div style ={{padding: "10px", textAlign: "right"}}>
                                            <button onClick={this._onClick} style={{fontSize: "150%"}}>Run |></button>
                                        </div>
                                        <div><h2>Output:</h2></div>
                                        <div id={"iframeholder"} className={"iframeholder"} ref={_ref => this.iframeholder = _ref}></div>
                                        {/* <div style={{ paddingTop: '30px', paddingBottom: '30px' }}><h2>Play with the properties:</h2></div>
                                        <div style={{borderWidth: "2px", borderStyle: "inset", borderColor: "initial", borderImage: "initial"}}> {contentDEMO} </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Tab>
                    <Tab  key={'2'} title='API'>
                        <div id="page-content-wrapper">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div style={{ paddingTop: '30px', paddingBottom: '30px' }}><h2>API:</h2></div>
                                        <p> {contentDOC} </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Tab>
                    <Tab key={'3'} title='React'>
                        <div id="page-content-wrapper">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div style={{ paddingTop: '30px', paddingBottom: '30px' }}><h2>React code:</h2></div>
                                        <SyntaxHighlighter language='javascript' style={docco}>
                                            {contentDEMOReact}
                                        </SyntaxHighlighter>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Tab>
                    <Tab key={'4'} title='jQuery'>
                        <div id="page-content-wrapper">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div style={{ paddingTop: '30px', paddingBottom: '30px' }}><h2>jQuery code:</h2></div>
                                        <SyntaxHighlighter language='javascript' style={docco}>
                                            {contentDEMOJQ}
                                        </SyntaxHighlighter>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Tab>
                    <Tab key={'5'} title='Vue'>
                        <div id="page-content-wrapper">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div style={{ paddingTop: '30px', paddingBottom: '30px' }}><h2>Angular code:</h2></div>
                                        <SyntaxHighlighter language='javascript' style={docco}>
                                            {contentDEMOVue}
                                        </SyntaxHighlighter>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Tab>
                </Tabs>
                </div>
            );
        }
        const mainTitle = (title === 'Get Started' || title === 'Home') ? tag : title + ' ' + '||' + ' ' + tag
        return (
            <div>
                <h1 style={{ paddingLeft: '20px', paddingBottom: '0px', paddingTop: '30px' }}> {mainTitle}</h1>
                {Content}
            </div>
        );
    }
}


Content.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    contentDEMO: PropTypes.object,
    contentDEMOReact: PropTypes.string,
    contentDEMOJQ: PropTypes.string,
    contentDEMOVue: PropTypes.string,
    contentDOC: PropTypes.string,
    src: PropTypes.string
};

export default Content;



// WEBPACK FOOTER //
// ./src/Content2.js